var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16666 5.33374C5.14946 5.33679 4.58652 5.36112 4.12394 5.55528C3.476 5.82724 2.94834 6.3296 2.64009 6.96799C2.38848 7.48906 2.34731 8.15666 2.26496 9.49187L2.13593 11.5841C1.93116 14.9044 1.82876 16.5646 2.80307 17.6156C3.77737 18.6666 5.41877 18.6666 8.7016 18.6666H11.9651C15.2479 18.6666 16.8893 18.6666 17.8636 17.6156C18.8379 16.5646 18.7355 14.9044 18.5308 11.5841L18.4017 9.49187C18.3193 8.15666 18.2782 7.48906 18.0266 6.96799C17.7183 6.3296 17.1907 5.82724 16.5428 5.55528C16.0802 5.36112 15.5172 5.33679 14.5 5.33374",
    fill: "#D35258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16666 5.33374C5.14946 5.33679 4.58652 5.36112 4.12394 5.55528C3.476 5.82724 2.94834 6.3296 2.64009 6.96799C2.38848 7.48906 2.34731 8.15666 2.26496 9.49187L2.13593 11.5841C1.93116 14.9044 1.82876 16.5646 2.80307 17.6156C3.77737 18.6666 5.41877 18.6666 8.7016 18.6666H11.9651C15.2479 18.6666 16.8893 18.6666 17.8636 17.6156C18.8379 16.5646 18.7355 14.9044 18.5308 11.5841L18.4017 9.49187C18.3193 8.15666 18.2782 7.48906 18.0266 6.96799C17.7183 6.3296 17.1907 5.82724 16.5428 5.55528C16.0802 5.36112 15.5172 5.33679 14.5 5.33374",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 6.16667L13.7617 4.32119C13.4432 3.52497 13.166 2.62175 12.347 2.21629C11.9102 2 11.3845 2 10.3332 2C9.28184 2 8.75617 2 8.3193 2.21629C7.50034 2.62175 7.22318 3.52497 6.9047 4.32119L6.1665 6.16667",
    fill: "#D35258"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 6.16667L13.7617 4.32119C13.4432 3.52497 13.166 2.62175 12.347 2.21629C11.9102 2 11.3845 2 10.3332 2C9.28184 2 8.75617 2 8.3193 2.21629C7.50034 2.62175 7.22318 3.52497 6.9047 4.32119L6.1665 6.16667",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2498 11.9999C13.2498 13.6108 11.944 14.9166 10.3332 14.9166C8.72234 14.9166 7.4165 13.6108 7.4165 11.9999C7.4165 10.3891 8.72234 9.08325 10.3332 9.08325C11.944 9.08325 13.2498 10.3891 13.2498 11.9999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 5.33325H10.3405Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 5.33325H10.3405",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAdd);
export default __webpack_public_path__ + "static/media/camera-add.bca3418e15ac03a00534c62c736b16f6.svg";
export { ForwardRef as ReactComponent };